module.exports = __webpack_public_path__ + "static/notfound-8acb8cc17e551ccd8a32967c8ae39c85.webp";